import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UserDetail, VipBenefits, VipSetting } from '../interfaces/vip.interface';
import { BaseApi } from './base.api';
@Injectable({
  providedIn: 'root',
})
export class VipApi extends BaseApi {
  //查询用户VIP
  getUserVip(): Observable<any> {
    const url = `${environment.apiUrl}/v1/member/vip/uservip`;
    return this.get(url);
  }

  /**
   * 查询vip等级设定
   *
   * @param params
   * @param { level: number}  level 当前vip等级 不传返回 0 - 10
   * @param params.level
   */
  getVipSetting(params?: { level: number }): Observable<VipSetting[]> {
    const url = `${environment.apiUrl}/v1/member/vip/vipsetting`;
    return this.get(url, params).pipe(
      map(
        (x: any) =>
          x?.data || [
            {
              birthdayBonus: 0,
              cardReturn: 0,
              dayWithdrawLimitMoney: 0,
              firstDepositBonus: 0,
              gameReturn: 0,
              keepBonus: 0,
              loginRedPackage: 0,
              lotteryReturn: 0,
              personReturn: 0,
              promotionBonus: 0,
              rescueMoney: 0,
              sportsReturn: 0,
              totalBonus: 0,
              vipLevel: '0',
            },
          ],
      ),
    );
  }

  //vip福利列表
  getVipBenefits(): Observable<VipBenefits> {
    const url = `${environment.apiUrl}/v1/member/vip/vipbenefits`;
    return this.get(url).pipe(map((x: any) => x?.data || []));
  }

  //VIPc 新接口

  // 会员详情
  getUserDetail(): Observable<UserDetail> {
    const url = `${environment.apiUrl}/v1/member/vipa/getuserdetail`;
    return this.get(url).pipe(map((x: any) => x?.data || []));
  }

  // 等级配置列表
  getLevelDetailList(): Observable<any> {
    const url = `${environment.apiUrl}/v1/member/vipa/getleveldetaillist`;
    return this.get(url).pipe(map((x: any) => x?.data || []));
  }

  // 等级分组列表
  // getLevelGroupList(): Observable<VipLevelGroup[]> {
  //   const url = `${environment.apiUrl}/v1/member/vipa/getlevelgrouplist`;
  //   return this.get(url).pipe(map((x: any) => x?.data || []));
  // }

  //积分配置列表
  getLevelPointslist(): Observable<any> {
    const url = `${environment.apiUrl}/v1/member/vipc/getlevelpointslist`;
    return this.get(url).pipe(map((x: any) => x?.data || []));
  }
}
